

import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { Locale } from "@/lib/i18n/config";
import { useSubscriptionsQuery } from "@/shared/services/useSubscriptionsQuery";
import { BackButton } from "@/shared/layout/BackButton";
import { SellerCreateForm } from "../components/SellerCreateForm";
import { LoadingSkeleton, ErrorState, SectionCard } from "@a2z/ui";

type SellerCreatePageProps = {
  locale: Locale;
};

export function SellerCreatePage({ locale }: SellerCreatePageProps) {
  const t = useTranslations();
  const { data, isLoading, error, refetch } = useSubscriptionsQuery();

  if (isLoading) {
    return <LoadingSkeleton variant="card" />;
  }

  if (error) {
    return <ErrorState onRetry={refetch} />;
  }

  const plans = data?.items ?? [];
  if (plans.length === 0) {
    return (
      <div className="text-sm text-[color:var(--text-muted)]">
        {t(keys.common.empty)}
      </div>
    );
  }

  return (
    <section className="flex w-full max-w-2xl flex-col gap-5 lg:px-6 lg:py-6">
      <BackButton
        label={t(keys.common.back)}
        fallbackHref={`/${locale}/admin/sellers`}
      />
      <SectionCard title={t(keys.admin.sellersNewTitle)}>
        <SellerCreateForm locale={locale} plans={plans} />
      </SectionCard>
    </section>
  );
}
